var Test = {
  storage: (function() {
    let test = 'test'
    try {
      localStorage.setItem(test, test)
      localStorage.removeItem(test)
      return true
    } catch (e) {
      return false
    }
  })(),
  json: function(str) {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  }
}

export const setStorageItem = (key, data) => {
  // Make sure local storage is supported.
  if (!Test.storage) return

  // Make sure there is a key and a value.
  if (!key || !data) {
    throw new Error('There is a key or value missing.')
  }

  // Check if data is an object or string.
  let value = typeof data === 'string' ? data : JSON.stringify(data)

  // Store it.
  localStorage.setItem(key, value) // value: data
}

export const getStorageItem = key => {
  // Make sure local storage is supported.
  if (!Test.storage) {
    return
  }

  // Make sure there is a key.
  if (!key) {
    return 'No key!'
  }

  // Get the value from storage.
  let value = localStorage.getItem(key)

  return Test.json(value) ? JSON.parse(value) : value
}

export const removeStorageItem = key => {
  if (!Test.storage) {
    return
  }

  localStorage.removeItem(key)
}

export default {
  set: setStorageItem,
  get: getStorageItem,
  remove: removeStorageItem
}
